import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal/Modal';
import UscDataCaptureForm from '../UscDataCaptureForm/UscDataCaptureForm';

import { getCookie, setCookie } from '../../Utils/FormUtils';

var UscDataCaptureModal = function UscDataCaptureModal(_ref) {
  var handleFormSubmitDiscountCode = _ref.handleFormSubmitDiscountCode,
      formDiscount = _ref.formDiscount;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalActive = _useState2[0],
      setModalActive = _useState2[1];

  var delay = 10000;

  useEffect(function () {
    var viewCookie = getCookie('dormify_modal_form_viewed');
    var submittedCookie = getCookie('dormify_modal_form_submitted');
    var isUscPage = window.location.pathname.includes('/pages/usc');
    // if no view cookie or submitted cookie, fire delayed modal
    if (!viewCookie && !submittedCookie && isUscPage) {
      var delayFireModal = setTimeout(function () {
        setModalActive(true);
        setCookie('dormify_modal_form_viewed', true, 90);
      }, delay);
      return function () {
        return clearTimeout(delayFireModal);
      };
    }
  }, [setModalActive]);

  return React.createElement(
    Modal,
    {
      active: modalActive,
      closeModalFunc: function closeModalFunc() {
        return setModalActive(false);
      },
      closeOnOutsideClick: false,
      dataCapture: true
    },
    React.createElement(UscDataCaptureForm, {
      handleFormSubmitDiscountCode: handleFormSubmitDiscountCode,
      formDiscount: formDiscount,
      isModal: true
    })
  );
};

UscDataCaptureModal.propTypes = {
  handleFormSubmitDiscountCode: PropTypes.func,
  formDiscount: PropTypes.object
};

export default UscDataCaptureModal;